import React from 'react';
import AppointmentForm from '../components/AppointmentForm';
import Icon from '../components/icons/Icon';
import SEO from '../components/SEO';
import { PHONE, PHONE_DISPLAY, SITE_URL } from '../config/site';
import './AppointmentPage.css';

const AppointmentPage = () => (
  <>
    <SEO 
      title="Book Appointment - Dr. Muyabin Dental Care"
      description="Book your dental appointment with Dr. Muyabin in Dar es Salaam, Tanzania. Professional dental care services available."
      keywords="book dentist appointment Tanzania, dental appointment Dar es Salaam, schedule dental visit"
      url={`${SITE_URL}/appointment`}
    />
    <section className="appointment-page" id="appointment">
    <div className="appointment-container">
      <div className="appointment-header">
        <span className="appointment-subtitle">Book Appointment</span>
        <h1 className="appointment-title">Schedule Your Visit</h1>
        <p className="appointment-description">
          Fill out the form below to request an appointment. We'll contact you soon 
          to confirm your preferred date and time.
        </p>
      </div>

      <div className="appointment-content">
        <div className="appointment-info">
          <div className="info-card">
            <div className="info-icon"><Icon name="clock" size={28} /></div>
            <h3>Office Hours</h3>
            <p><strong>Monday - Friday:</strong> 8:00 AM - 8:00 PM</p>
            <p><strong>Saturday:</strong> 8:00 AM - 6:00 PM</p>
            <p><strong>Sunday:</strong> Closed</p>
          </div>

          <div className="info-card">
            <div className="info-icon"><Icon name="phone" size={28} /></div>
            <h3>Emergency Contact</h3>
            <p>For urgent dental issues, please call:</p>
            <p><strong><a href={`tel:${PHONE}`}>{PHONE_DISPLAY}</a></strong></p>
          </div>

          <div className="info-card">
            <div className="info-icon"><Icon name="info" size={28} /></div>
            <h3>What to Expect</h3>
            <p>After submitting your request, our team will contact you within 24 hours to confirm your appointment time and answer any questions.</p>
          </div>
        </div>

        <div className="appointment-form-wrapper">
          <AppointmentForm />
        </div>
      </div>
    </div>
  </section>
  </>
);

export default AppointmentPage;

